export const EGM_A_COOKIE = 'a-session-id' // Enrollment session cookie
export const EGM_COOKIE = 'e-session-id'
export const RISK_COOKIE = 's-session-id'
export const FULL_STORY_COOKIE = 'p-session-id'
export const APPLICATION_COOKIE = 'a-id'
export const PARTY_ID_COOKIE = 'u-id'
export const EGM_CACHE = 'EGM CACHE'
// Cache Session Storage Time
export const IMMEDIATELY = 0
// Time Calculated in Milliseconds
export const ONE_SECOND = 1000
export const THREE_SECONDS = ONE_SECOND * 3
export const TEN_SECONDS = ONE_SECOND * 10
export const FIFTY_NINE_SECONDS = ONE_SECOND * 59
export const ONE_MINUTE = ONE_SECOND * 60
export const TWO_MINUTES = ONE_MINUTE * 2
export const FIVE_MINUTES = ONE_MINUTE * 5
export const TEN_MINUTES = ONE_MINUTE * 10
export const TWENTY_MINUTES = ONE_MINUTE * 20
export const ONE_HOUR = ONE_MINUTE * 60
export const ONE_DAY = ONE_HOUR * 24

export const IS_RECOVERY_PARAM = 'isRecovery'

export const SESSION_TIMEOUT_PARAM = 'session-timeout'
